exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pz_modal .modal-header > .fa.fa-times {\n  cursor: pointer;\n}\n.pz_modal .modal-header > .lean-icon.information-fill::before {\n  transform: scale(0.7);\n}\n", ""]);

